import { render, staticRenderFns } from "./InvitationPopup.vue?vue&type=template&id=3c44a9b0"
import script from "./InvitationPopup.vue?vue&type=script&lang=js"
export * from "./InvitationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports